module.exports = __webpack_public_path__ + "static/favicon-6c5623b8a2cfc2cd4ff8f743b6d98a84.ico";